/**
 * Generated from ch10_p01.fla
 */
export function ch10_p01(this: Ich10_p01) {
	const confetti = this.confetti;
	if (!confetti[0] && confetti.elementFactory) {
		confetti[0] = confetti.elementFactory(0,undefined);
	}
	if (confetti[0]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettipink.call(confetti[0] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettipink);
		confetti[0].x = 854.25;
		confetti[0].y = 413.5;
		confetti[0].width = 1403.50;
		confetti[0].height = 646.00;
		confetti[0].alpha = 1;
		if (confetti[0].onLayout) confetti[0].onLayout();
	}
	if (!confetti[1] && confetti.elementFactory) {
		confetti[1] = confetti.elementFactory(1,undefined);
	}
	if (confetti[1]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite.call(confetti[1] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite);
		confetti[1].x = 870.25;
		confetti[1].y = 371.5;
		confetti[1].width = 1493.50;
		confetti[1].height = 726.00;
		confetti[1].alpha = 1;
		if (confetti[1].onLayout) confetti[1].onLayout();
	}
	if (!confetti[2] && confetti.elementFactory) {
		confetti[2] = confetti.elementFactory(2,undefined);
	}
	if (confetti[2]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77.call(confetti[2] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77);
		confetti[2].x = 806;
		confetti[2].y = 363.5;
		confetti[2].width = 1247.00;
		confetti[2].height = 623.00;
		confetti[2].alpha = 1;
		if (confetti[2].onLayout) confetti[2].onLayout();
	}
	if (!confetti[3] && confetti.elementFactory) {
		confetti[3] = confetti.elementFactory(3,undefined);
	}
	if (confetti[3]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy.call(confetti[3] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy);
		confetti[3].x = 878.25;
		confetti[3].y = 469;
		confetti[3].width = 1347.50;
		confetti[3].height = 526.00;
		confetti[3].alpha = 1;
		if (confetti[3].onLayout) confetti[3].onLayout();
	}
	if (!confetti[4] && confetti.elementFactory) {
		confetti[4] = confetti.elementFactory(4,undefined);
	}
	if (confetti[4]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78.call(confetti[4] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78);
		confetti[4].x = 947;
		confetti[4].y = 396;
		confetti[4].width = 1337.00;
		confetti[4].height = 712.00;
		confetti[4].alpha = 1;
		if (confetti[4].onLayout) confetti[4].onLayout();
	}
	if (!confetti[5] && confetti.elementFactory) {
		confetti[5] = confetti.elementFactory(5,undefined);
	}
	if (confetti[5]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy.call(confetti[5] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy);
		confetti[5].x = 790.5;
		confetti[5].y = 311.25;
		confetti[5].width = 1581.00;
		confetti[5].height = 622.50;
		confetti[5].alpha = 1;
		if (confetti[5].onLayout) confetti[5].onLayout();
	}
	if (!confetti[6] && confetti.elementFactory) {
		confetti[6] = confetti.elementFactory(6,undefined);
	}
	if (confetti[6]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79.call(confetti[6] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79);
		confetti[6].x = 856.25;
		confetti[6].y = 323.25;
		confetti[6].width = 1268.50;
		confetti[6].height = 554.50;
		confetti[6].alpha = 1;
		if (confetti[6].onLayout) confetti[6].onLayout();
	}
	if (!confetti[7] && confetti.elementFactory) {
		confetti[7] = confetti.elementFactory(7,undefined);
	}
	if (confetti[7]) {
		ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy.call(confetti[7] as Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy);
		confetti[7].x = 832;
		confetti[7].y = 380;
		confetti[7].width = 1664.00;
		confetti[7].height = 760.00;
		confetti[7].alpha = 1;
		if (confetti[7].onLayout) confetti[7].onLayout();
	}
	const bg = this.bg;
	ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const characters = this.characters;
	ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_characters.call(this.characters);
	characters.x = 835.75;
	characters.y = 768;
	characters.width = 1028.50;
	characters.height = 686.50;
	characters.alpha = 1.00;
	if (characters.onLayout) characters.onLayout();
	const frameRight = this.frameRight;
	ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_bg(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p10_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_characters(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_characters) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp10_p10_characters", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettipink(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettipink) {
	if (this.setLayoutTexture) this.setLayoutTexture("pink", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite) {
	if (this.setLayoutTexture) this.setLayoutTexture("white", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer77", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer77copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer78", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer78copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer79", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer79copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeRRframe(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeLLframe(this: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich10_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich10_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich10_p01Sprite extends Ich10_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich10_p01Text extends Ich10_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich10_p01Polygon extends Array<number> {
}
interface Ich10_p01 {
	readonly confetti: Ich10_p01Array<Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettipink|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79|Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy>;
	readonly bg: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_bg;
	readonly characters: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_characters;
	readonly frameRight: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeRRframe;
	readonly frameLeft: Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeLLframe;
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_bg extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_characters extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettipink extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiwhite extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77 extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiyellowLayer77copy extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78 extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfetticyanLayer78copy extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79 extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetconfettiredLayer79copy extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeRRframe extends Ich10_p01Sprite {
}
interface Ich10_p01_hh_ch010_72dpi_p01psdAssetchp10_p10_wcframeLLframe extends Ich10_p01Sprite {
}
